import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const imageVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
};

const textVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0 },
};

interface OurStoryProps {
  storyText: string;
}

const OurStory: React.FC<OurStoryProps> = ({ storyText }) => {
  const [ref, inView] = useInView({
    threshold: 0.2,
  });

  return (
    <motion.section
      ref={ref}
      className="flex flex-col md:flex-row flex-wrap global-container py-[2rem] bg-white rounded-[0.5rem] mb-[10rem]"
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={containerVariants}
      transition={{ duration: 0.8, ease: "easeInOut", staggerChildren: 0.3 }}
    >
      <motion.div
        className="w-full md:w-1/2"
        variants={imageVariants}
        transition={{ duration: 0.9, ease: "easeInOut" }}
      >
        <img
          className="rounded-[0.5rem]"
          src="/images/our-story2.jpg"
          alt="Our Story"
        />
      </motion.div>

      <motion.div
        className="pt-[2rem] md:pt-0 md:pl-[2rem] w-full md:w-1/2"
        variants={textVariants}
        transition={{ duration: 0.9, ease: "easeInOut" }}
      >
        <p className="max-w-full whitespace-pre-wrap">{storyText}</p>
      </motion.div>
    </motion.section>
  );
};

export default OurStory;
